import api from '../../services/service_pos'
// import Swal from 'sweetalert2'

export default {
  data () {
    return {
      bill_data: [],
      hostshift: '',
      search: '',
      currentPage: 1,
      items_perpage: 10,
      header: {
        headers: {
          'Access-Token': sessionStorage.token
        }
      },
      form_data: ''
    }
  },
  created () {
    this.checkUser()
    // if (sessionStorage.hostshift) {
    //   this.hostshift = JSON.parse(sessionStorage.hostshift)
    // } else {
    //   this.$router.push('/')
    // }
  },
  computed: {
    paginate: function () {
      this.totalItem = this.bill_data.length
      if (this.currentPage >= this.totalPages) {
        this.currentPage = Math.max(0, this.totalPages - 1)
      }
      var index = (this.currentPage - 1) * this.items_perpage
      return this.bill_data.slice(index, index + this.items_perpage)
    }
  },
  methods: {
    searchDetail () {
      clearTimeout(this.timeout)
      const self = this
      this.timeout = setTimeout(function () {
        // enter this block of code after 1 second
        // handle stuff, call search API etc.
        console.log(this.timeout)
        self.getBillAll()
      }, 400)
    },
    CheckSearch () {
      if (this.search === '') {
        this.onChange(1)
        this.getBillAll()
      }
    },
    itemRender (current, type, originalElement) {
      if (type === 'prev') {
        return 'Previous'
      } else if (type === 'next') {
        return 'Next'
      }
      return originalElement
    },
    onChange (pageNumber) {
      this.currentPage = pageNumber
    },
    getBillAll () {
      // this.$store.commit('Loading')
      var obj = {
        'host_code': '01',
        'keyword': this.search
      }
      api.billPosList(
        this.REST_URL,
        obj,
        this.header,
        result => {
          if (result.response === 'success') {
            this.bill_data = []
            result.data.forEach(val => {
              if (val['holding_status'] === 0 && val['is_cancel'] === 0) {
                this.bill_data.push(val)
              }
            })
          } else {
            this.$notification['warning']({
              message: 'เปิดการขายไม่ได้',
              description: result.message
            })
          }
          // this.$store.commit('Loading')
        },
        error => {
          alert('ไม่สามารถเข้าถึงข้อมูล ' + JSON.stringify(error))
          // this.$store.commit('Loading')
        }
      )
    },
    // cancelBill (data) {
    //   $('#ToolModal').modal('hide')
    //   Swal.fire({
    //     title: 'ยกเลิกบิล',
    //     text: 'ท่านต้องการยกเลิกบิลขายเลขที่ ' + data.doc_no + ' ใช่หรือไม่ ?',
    //     icon: 'warning',
    //     showCancelButton: true,
    //     confirmButtonColor: '#3085d6',
    //     cancelButtonColor: '#d33',
    //     confirmButtonText: 'ตกลง',
    //     cancelButtonText: 'ปิด'
    //   }).then((res) => {
    //     if (res.value) {
    //       this.$store.commit('Loading')
    //       var obj = {
    //         'doc_no': data.doc_no
    //       }
    //       api.cancelBill(this.REST_URL,
    //         obj,
    //         this.header,
    //         result => {
    //           if (result.response === 'success') {
    //             this.$notification['success']({
    //               message: 'ยกเลิกบิล',
    //               description: 'ยกเลิกบิลเรียบร้อย'
    //             })
    //             this.search = ''
    //           } else {
    //             this.$notification['warning']({
    //               message: 'ยกเลิกบิล',
    //               description: 'ยกเลิกบิลไม่สมบูรณ์'
    //             })
    //           }
    //           this.$store.commit('Loading')
    //         },
    //         error => {
    //           alert('ไม่สามารถเข้าถึงข้อมูล ' + JSON.stringify(error))
    //         }
    //       )
    //     } else {
    //       $('#ToolModal').modal('show')
    //     }
    //   })
    // },
    // printBill (docNo) {
    //   this.$store.commit('Loading')
    //   var obj = {
    //     'printer_port': this.hostshift.printer_port,
    //     'doc_no': docNo
    //   }
    //   api.printBill(this.REST_URL,
    //     obj,
    //     this.header,
    //     result => {
    //       if (result.response === 'success') {
    //         this.$notification['success']({
    //           message: 'พิมพ์ใบเสร็จสำเร็จ',
    //           description: result.message
    //         })

    //         this.$store.commit('Loading')
    //       } else {
    //         this.$notification['warning']({
    //           message: 'พิมพ์ใบเสร็จไม่ได้',
    //           description: result.message
    //         })
    //         this.$store.commit('Loading')
    //       }
    //     },
    //     error => {
    //       alert('ไม่สามารถเข้าถึงข้อมูล ' + JSON.stringify(error))
    //       this.$store.commit('Loading')
    //     }
    //   )
    // },
    printPDF (obj) {
      this.$store.commit('Loading')
      api.billCreditDetail(this.REST_URL,
        this.header,
        { doc_no: obj.doc_no },
        result => {
          if (result.response === 'success') {
            this.form_data = JSON.stringify(result.data)
            setTimeout(() => {
              this.$refs.printHolding.submit()
              this.$store.commit('Loading')
            }, 1000)
          } else {
            this.$notification['warning']({
              message: 'พิมพ์ใบแจ้งยอดไม่ได้',
              description: result.message
            })
            this.$store.commit('Loading')
          }
        },
        error => {
          this.$store.commit('Loading')
          alert('ไม่สามารถเข้าถึงข้อมูล ' + JSON.stringify(error))
        })
    },
    openDetailBill (val) {
      console.log(val)
      this.$store.state.detail_pop = val
      $('#itemDetailBill').modal('show')
    }
  },
  mounted () {
    this.search = ''
    this.getBillAll()
  }
}



// WEBPACK FOOTER //
// ./src/assets/js/re_print_list.js